import { render, staticRenderFns } from "./bankruptcyManagerCheck.vue?vue&type=template&id=0f19762a&scoped=true&"
import script from "./bankruptcyManagerCheck.vue?vue&type=script&lang=js&"
export * from "./bankruptcyManagerCheck.vue?vue&type=script&lang=js&"
import style0 from "./bankruptcyManagerCheck.vue?vue&type=style&index=0&id=0f19762a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19762a",
  null
  
)

export default component.exports